import { getModalByTemplate } from "../../modal"

export function requestsCertificates() {

  if (formGetCertificate()) {
    return formGetCertificate();
  }

  if (formValidateCertificate()) {
    return formValidateCertificate();
  }

  if (formGetCertificateSpeeches()) {
    return formGetCertificateSpeeches();
  }

  function formGetCertificate() {
    var form = document.querySelector("#form-certificate")
    var btnSubmit = document.querySelector('.btn-certificates')

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      btnSubmit.classList.add("loading")

      var CRAFT_CSRF_NAME = window.csrfTokenName;
      var CRAFT_CSRF_TOKEN = window.csrfTokenValue;

      let formData = new FormData()
      formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN)
      formData.append('cpf', document.querySelector('#cpf-participante').value);

      fetch('/actions/general-module/certificado/listar', {
        method: "POST",
        body: formData,
      }).then((response) => {
          return response.json();
      }).then((json) => {
          getModalByTemplate("certificates", null, { data: json });
          btnSubmit.classList.remove("loading")
      });
    })
  }

  function formValidateCertificate() {
    var form = document.querySelector("#form-validate-certificate")
    var btnSubmit = document.querySelector('.btn-validate-certificates')

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      btnSubmit.classList.add("loading")

      var CRAFT_CSRF_NAME = window.csrfTokenName;
      var CRAFT_CSRF_TOKEN = window.csrfTokenValue;

      let formData = new FormData()
      formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN)
      formData.append('codigo', document.querySelector('#codigo').value);

      fetch('/actions/general-module/certificado/validar', {
        method: "POST",
        body: formData,
      }).then((response) => {
          return response.json();
      }).then((json) => {
          getModalByTemplate("validate-certificates", null, { data: json });
          btnSubmit.classList.remove("loading")
      });
    })
  }

  function formGetCertificateSpeeches() {
    var form = document.querySelector("#form-get-certificate-speeches")
    var btnSubmit = document.querySelector('.btn-certificate-speeches')

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      btnSubmit.classList.add("loading")

      var CRAFT_CSRF_NAME = window.csrfTokenName;
      var CRAFT_CSRF_TOKEN = window.csrfTokenValue;

      let formData = new FormData()
      formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN)
      formData.append('cpf', document.querySelector('#cpf-evento').value);

      fetch('/actions/general-module/certificado/listar-certificado-evento', {
        method: "POST",
        body: formData,
      }).then((response) => {
        return response.json();
      }).then((json) => {
        getModalByTemplate("certificate-events", null, { data: json });
        btnSubmit.classList.remove("loading")
      });
    })
  }
}

if (document.querySelector("#form-get-certificate") || document.querySelector("#form-get-speeches")) {
  requestsCertificates();
}